import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import Logo from "@/components/Logo";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're on the list. Welcome to Vixera.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="border-t border-white/10 bg-velvet-ink" data-testid="footer">
      <div className="mx-auto max-w-[1600px] px-6 py-24 md:px-12">
        <div className="grid grid-cols-1 gap-16 md:grid-cols-12">
          <div className="md:col-span-6">
            <h2 className="max-w-lg font-heading text-4xl font-light leading-none tracking-tight text-white md:text-5xl">
              Join the inner circle
            </h2>
            <p className="mt-6 max-w-md text-sm font-light text-white/50">
              Receive discreet introductions to newly verified companions and
              private invitations. Unsubscribe anytime.
            </p>
            <form onSubmit={subscribe} className="mt-10 flex max-w-md border-b border-white/20 pb-2">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                data-testid="newsletter-input"
                className="w-full bg-transparent text-sm text-white placeholder:text-white/30 focus:outline-none"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="newsletter-submit"
                className="shrink-0 text-xs uppercase tracking-luxe text-velvet-gold transition-opacity hover:opacity-70 disabled:opacity-40"
              >
                {loading ? "..." : "Subscribe"}
              </button>
            </form>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <p className="mb-6 text-xs uppercase tracking-luxe text-white/40">Explore</p>
            <ul className="space-y-4 text-sm text-white/70">
              <li><Link to="/directory" className="transition-colors hover:text-velvet-gold">Directory</Link></li>
              <li><Link to="/directory?city=johannesburg" className="transition-colors hover:text-velvet-gold">Johannesburg</Link></li>
              <li><Link to="/directory?city=cape-town" className="transition-colors hover:text-velvet-gold">Cape Town</Link></li>
              <li><Link to="/membership" className="transition-colors hover:text-velvet-gold">Membership</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="mb-6 text-xs uppercase tracking-luxe text-white/40">Account</p>
            <ul className="space-y-4 text-sm text-white/70">
              <li><Link to="/login" className="transition-colors hover:text-velvet-gold">Sign In</Link></li>
              <li><Link to="/register" className="transition-colors hover:text-velvet-gold">Register</Link></li>
              <li><Link to="/account" className="transition-colors hover:text-velvet-gold">Favourites</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-24 flex flex-col items-start justify-between gap-6 border-t border-white/10 pt-10 md:flex-row md:items-center">
          <p className="text-3xl tracking-tight text-white">
            <Logo markSize={26} className="text-3xl" />
          </p>
          <p className="max-w-sm text-xs leading-relaxed text-white/30">
            18+ only. Vixera is a companionship directory. All companions are
            independent adults. &copy; {new Date().getFullYear()} Vixera.
          </p>
        </div>
      </div>
    </footer>
  );
}
